<template>
  <v-card>
    <offer-status :active="item.active"></offer-status>
    <div class="pa-3" style="position:relative;">
      <p class="mb-0">{{ item.service }} | {{ item.serviceItem }}</p>
      <h3 class="headline primary--text">
        {{ item.title }}
      </h3>
      <kimsa-countdown class="cuenta"  :date="item.expires" ref="countdown"></kimsa-countdown>
      <h6 class="primary--text mt-2">Promoción creada el:</h6>
      <p class="mb-0">
        {{ $moment(item.created).format('ddd DD MMM YYYY HH:mm') }}
      </p>
      <h6 class="primary--text mt-2">Promoción finaliza el:</h6>
      <p class="mb-0">
        {{ $moment(item.expires).format('ddd DD MMM YYYY HH:mm') }}
      </p>
      <p v-html="item.description" class="text-xs-justify mt-2"></p>
    </div>
    <!-- <pre>
        {{item}}
      </pre> -->
    <v-divider class="mt-3"></v-divider>
    <slot></slot>
  </v-card>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    OfferStatus: () => import('@/components/providers/offers/OfferStatus'),
    KimsaCountdown: () => import('@/components/common/KimsaCountdown')
  },
  methods: {
    updateRemaining() {
      this.$refs.countdown.updateRemaining()
    }
  }

}
</script>
<style scoped>
.cuenta {
  position: absolute;
  width: 40%;
  top: 95px;
  right: 30px;
}
</style>